// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__Uz94V","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2KDPE"};